"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _cuid = _interopRequireDefault(require("cuid"));
var SmileyVeryHappyFill = function SmileyVeryHappyFill(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    uniqueId: uniqueId
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 0C4.48567 0 0 4.48567 0 10C0 15.5143 4.48567 20 10 20C15.5143 20 20 15.5143 20 10C20 4.48567 15.5143 0 10 0ZM13.0557 5.41667C13.8997 5.41667 14.5833 6.101 14.5833 6.94433C14.5833 7.78833 13.8997 8.472 13.0557 8.472C12.2117 8.472 11.528 7.78833 11.528 6.94433C11.5277 6.101 12.2113 5.41667 13.0557 5.41667ZM6.94433 5.41667C7.78833 5.41667 8.472 6.101 8.472 6.94433C8.472 7.78833 7.78833 8.472 6.94433 8.472C6.10033 8.472 5.41667 7.78833 5.41667 6.94433C5.41667 6.101 6.10033 5.41667 6.94433 5.41667ZM10 16.875C7.15133 16.875 4.65266 14.3763 4.65266 11.5277C4.65266 11.106 4.994 10.7637 5.41667 10.7637H14.5833C15.0057 10.7637 15.3473 11.106 15.3473 11.5277C15.3473 14.3763 12.8487 16.875 10 16.875Z"
  }));
};
var _default = exports["default"] = SmileyVeryHappyFill;